import React, { Component } from 'react'
import PropTypes from 'prop-types'
import LoadingIcon from '../LoadingIcon'

class CustomTourOperator extends Component {
  componentDidMount() {
    this.props.requestUser()
  }

  render() {
    const {
      showCustomTourOperator,
      userTourOperatorCode,
      classes,
      isFetching,
    } = this.props
    if (!showCustomTourOperator) return null

    return (
      <div className={classes.container}>
        {isFetching ? (
          <LoadingIcon />
        ) : (
          <h4 className={classes.title}>{userTourOperatorCode}</h4>
        )}
      </div>
    )
  }
}

CustomTourOperator.propTypes = {
  requestUser: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  showCustomTourOperator: PropTypes.bool,
  userTourOperatorCode: PropTypes.string,
  classes: PropTypes.shape({
    container: PropTypes.string,
    title: PropTypes.string,
  }),
}

export default CustomTourOperator
